import Logo from '@/components/common/Logo';
import SectionContainer from '@/components/common/SectionContainer';
import { Box, Flex, Text } from '@chakra-ui/react';
import Link from 'next/link';
import React from 'react';
import { FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';

const GreenReturnsFooter: React.FC<{}> = () => {
  const onEmailHandler = (mail1: string) => {
    window.open(`mailto: ${mail1}`);
  };

  return (
    <Box width="100%" py="30px" position="relative" bgColor="#F7F7FB">
      <SectionContainer>
        <Flex width="100%" justifyContent="space-between" flexWrap="wrap">
          <Flex
            w={{ xs: '100%', md: 'fit-content' }}
            justifyContent={{ xs: 'center', md: 'start' }}
            // mt={{ xs: '-130px', lg: '-120px' }}
            mb={{ xs: '50px' }}
          >
            {/* <Img
              src="https://static.levocdn.com/WGLBUT82/IVCA-GRSPartnershipwithNiti1-OaJ8LBunVyAB.png"
              w="350px"
              objectFit="contain"
              mt={{ xs: '-130px', lg: '-120px' }}
              mb={{ xs: '-100px' }}
              //   mx={{ xs: "auto" }}
            /> */}
            <Logo />
          </Flex>

          <Flex gap={{ base: '50px', md: '100px' }} flexWrap="wrap">
            <Flex flexDirection="column" alignItems="start" gap="14px">
              <Text
                color="black"
                fontSize="1rem"
                display="inline"
                fontWeight="bold"
              >
                Website
              </Text>
              <Link href="/greenReturns-2024">
                <Text
                  color="black"
                  fontSize="1rem"
                  display="inline"
                  _hover={{ color: '#197542' }}
                  cursor="pointer"
                >
                  Home
                </Text>
              </Link>
              <Link href="/greenReturns-2024/agenda">
                <Text
                  color="black"
                  fontSize="1rem"
                  display="inline"
                  _hover={{ color: '#197542' }}
                  cursor="pointer"
                >
                  Agenda
                </Text>
              </Link>
              <Link href="/greenReturns-2024/speakers">
                <Text
                  color="black"
                  fontSize="1rem"
                  display="inline"
                  _hover={{ color: '#197542' }}
                  cursor="pointer"
                >
                  Speakers
                </Text>
              </Link>

              <Link href="/greenReturns-2024/official-partners">
                <Text
                  color="black"
                  fontSize="1rem"
                  display="inline"
                  _hover={{ color: '#197542' }}
                  cursor="pointer"
                >
                  Official Partners
                </Text>
              </Link>
              <Link href="/greenReturns-2024/startups">
                <Text
                  color="black"
                  fontSize="1rem"
                  display="inline"
                  _hover={{ color: '#197542' }}
                  cursor="pointer"
                >
                  Startups Showcase
                </Text>
              </Link>
              <Link href="/greenReturns-2024/media">
                <Text
                  color="black"
                  fontSize="1rem"
                  display="inline"
                  _hover={{ color: '#197542' }}
                  cursor="pointer"
                >
                  Media
                </Text>
              </Link>
              {/* <Link href="/greenReturns-2024/register">
                <Text
                  color="black"
                  fontSize="1rem"
                  display="inline"
                  _hover={{ color: '#197542' }}
                  cursor="pointer"
                >
                  Registration
                </Text>
              </Link> */}
              <Link href="/greenReturns-2024/privacy-policy">
                <Text
                  color="black"
                  fontSize="1rem"
                  display="inline"
                  _hover={{ color: '#197542' }}
                  cursor="pointer"
                >
                  Privacy Policy
                </Text>
              </Link>
            </Flex>
            <Flex gap="24px" align="start" flexDirection="column">
              <Text
                color="black"
                fontSize="1rem"
                display="inline"
                fontWeight="bold"
              >
                Social Media
              </Text>
              <SocialMediaLink href="https://www.youtube.com/channel/UCEyV1l7ncz8m9xYVXlhGEeA">
                <Flex alignItems="center" gap="12px">
                  <FaYoutube size="24px" />
                  <Text
                    _hover={{ color: '#197542' }}
                    color="black"
                    fontSize="1rem"
                    display="inline"
                  >
                    Youtube
                  </Text>
                </Flex>
              </SocialMediaLink>
              <SocialMediaLink href="https://in.linkedin.com/company/indian-private-equity-venture-capital-association">
                <Flex alignItems="center" gap="12px">
                  <FaLinkedin size="24px" />
                  <Text
                    _hover={{ color: '#197542' }}
                    color="black"
                    fontSize="1rem"
                    display="inline"
                  >
                    LinkedIn
                  </Text>
                </Flex>
              </SocialMediaLink>
              <SocialMediaLink href="https://x.com/IndianVCA">
                <Flex alignItems="center" gap="12px">
                  <FaTwitter size="24px" />
                  <Text
                    _hover={{ color: '#197542' }}
                    color="black"
                    fontSize="1rem"
                    display="inline"
                  >
                    Twitter
                  </Text>
                </Flex>
              </SocialMediaLink>
            </Flex>
            <Flex flexDirection="column" alignItems="start" gap="14px">
              <Text
                color="black"
                fontSize="1rem"
                display="inline"
                fontWeight="bold"
              >
                Contact
              </Text>
              <Flex
                columnGap="12px"
                alignItems="center"
                onClick={() => onEmailHandler('info@ivca.in')}
                cursor="pointer"
                _hover={{ color: '#197542' }}
              >
                <IoMdMail size={25} />
                <Text
                  _hover={{ color: '#197542' }}
                  color="black"
                  fontSize="1rem"
                  display="inline"
                >
                  info@ivca.in
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          width="100%"
          flexDirection={{ xs: 'column', lg: 'row' }}
          alignItems="end"
          mt={{ xs: '22px', lg: '0px' }}
        >
          <Box width="100%">
            <Text fontWeight="bold" fontSize="1.75rem" color="black" mb="10px">
              Join the <br /> conversation
            </Text>

            <Text color="black" fontSize="1rem">
              Stay up to date with the latest news and updates at IVCA
            </Text>
          </Box>
          <Flex align="center" mt="1rem" gap="24px" w="100%">
            <Flex align="center" columnGap="32px" rowGap="20px" flexWrap="wrap">
              <Text color="black" fontSize=".875rem">
                Designed & Developed by{' '}
                <Link href="https://theinternetfolks.com" passHref>
                  <Text
                    as="a"
                    textDecoration="underline"
                    color="black"
                    target="_blank"
                    fontSize="black"
                  >
                    The Internet Folks
                  </Text>
                </Link>
              </Text>
              <Text color="black" fontSize=".875rem">
                Copyright © 2024 IVCA. All rights reserved.
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </SectionContainer>
    </Box>
  );
};

const SocialMediaLink: React.FC<{
  href: string;
  children: React.ReactNode;
}> = ({ href, children }) => (
  <Link href={href}>
    <Text color="black" _hover={{ color: '#197542' }}>
      {children}
    </Text>
  </Link>
);

export default GreenReturnsFooter;
